import { useTranslation } from 'react-i18next'

import { NEWSBOARD_STATUS } from '../../../../../../constants/newsboard'
import { useUkTimeZone } from '../../../../../../hooks'
import { Divider, DIVIDER_STYLE } from '../../../../../Divider'
import { Status } from '../../../../../Status'
import Text from '../././../../../../Text'

import {
  QA_NAME_POST_PERIOD,
  QA_NAME_POST_STATUS,
  QA_NAME_POST_TYPE,
} from './PostInfo.constants'
import { parsePostData } from './PostInfo.utils'

import * as styles from './PostInfo.module.css'

function PostInfo({ data }) {
  const { t } = useTranslation()

  const ukLocaleTimeZone = useUkTimeZone()

  const post = parsePostData(data, ukLocaleTimeZone)

  return (
    <div className={styles.PostInfo}>
      {post?.status ? (
        <>
          <Status
            qaName={QA_NAME_POST_STATUS}
            text={t(NEWSBOARD_STATUS[post.status].text)}
            textColor={NEWSBOARD_STATUS[post.status].textColor}
          />
          <Divider className={styles.divider} style={DIVIDER_STYLE.Round} />
        </>
      ) : null}
      <Text isSecondary qaName={QA_NAME_POST_TYPE}>
        {t(post.typeKey)}
      </Text>
      <Divider className={styles.divider} style={DIVIDER_STYLE.Round} />
      <Text isSecondary className={styles.date} qaName={QA_NAME_POST_PERIOD}>
        {post.time}
      </Text>
    </div>
  )
}

export default PostInfo
